import {Step} from '../Step/Step'
import {MaximizedOptions} from './MaximizedOptions'
import {MinimizedOptions} from './MinimizedOptions'

export const Options = () => {
  return (
    <Step
      caption="Which tour suits you best?"
      title="Tour"
      thisStepCode="option"
      minimizedComponent={MinimizedOptions}
      maximizedComponent={MaximizedOptions}
    />
  )
}
